// extracted by mini-css-extract-plugin
export default {"heading":"ProfileUploadPhoto_heading__FTSkU","imagesRow":"ProfileUploadPhoto_imagesRow__7TFOu","ImgDiv":"ProfileUploadPhoto_ImgDiv__rgCAV","Img":"ProfileUploadPhoto_Img__isKOW"};